import React from "react";
//import { app, db } from '../firebase.js';
//import { collection, addDoc, getFirestore, getDocs } from "firebase/firestore";
/*import {
  getStorage,
  ref,
  uploadString,
  uploadBytes,
  getDownloadURL
} from 'firebase/storage';*/
import Navbar from './Navbar'
import { Link } from "react-router-dom";

// Create a root reference
//const storage = getStorage(app);

 const IngresoPoliza = () => {
/*
  const [rut, changeRut] = useState('');
  const [typeSini, changetypeSini] = useState('');
  const [card, changeCard] = useState('');
  // const [photo, upPhoto] = useState('');
  const [descrip, changeDescrip] = useState('');
  const [location, changeLocation] = useState('');
  const [date, changeDate] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();

    addDoc(collection(db, 'siniestros'), {
      Rut: rut,
      TypeSini: typeSini,
      Card: card,
      // Photo: photo,
      Descrip: descrip,
      Location: location,
      Date: date,
      Status: "Solicitud ingresada",
      Number: 1,

    });
    e.target.reset();
  }

  const upPhoto = (e) => {
    // detectar archivo
    const archivoLocal = e.target.files[0];
    console.log(archivoLocal)
    // cargarlo a firebase storage
    const archivoRef = ref(storage, `documentos/${archivoLocal.name}`);
    console.log(archivoRef)

    uploadBytes(archivoRef, archivoLocal).then((snapshot) => {
      console.log('Uploaded a blob or file!');
    }); 

  }*/
  return (
    <div className="mt-1 mx-4">
      <Navbar></Navbar>
      <h1 id="title-sinister">Ingreso de siniestro</h1>
      <p className='text-white'>Campos obligtorios (*)</p>

      <form action="" /* onSubmit={onSubmit} */>
        <input
          className="form-control bg-white"
          type="number"
          name="rut"
          /*onChange={(e) => changeRut(e.target.value)}*/
          placeholder="Rut"
        />
        <p className='text-white'>Nunca compartiremos tus datos personales</p>
        <p className='text-white'>Selecciona el tipo de siniestro</p>
        <select
          className="form-control bg-white"
          name="sinister"
          /*onChange={(e) => changetypeSini(e.target.value)}*/
        >
          <option selected className="bg-white">Tipo de siniestro</option>
          <option className="bg-white" value="Choque">Choque</option>
          <option className="bg-white" value="Asistencia en ruta">Asistencia en ruta</option>
          <option className="bg-white" value="Robo">Robo</option>
        </select>

        <p className='text-white mt-4'>Selecciona el vehículo asegurado</p>
        <select
          className="form-control bg-white"
          name="card"
          /*onChange={(e) => changeCard(e.target.value)}*/
        >
          <option selected className="bg-white">Vehículo asegurado</option>
          <option className="bg-white" value="1">Vehículo 1</option>
          <option className="bg-white" value="2">Vehículo 2</option>
          <option className="bg-white" value="3">Vehículo 3</option>
        </select>

        <p className='text-white mt-4'>Adjunta fotografías nítidas (*)</p>
        <div class="custom-file">
          <input
            type="file"
            className="custom-file-input text-white"
            id="customFile"
            name="photo"
           /* onChange={upPhoto}*/
          // onChange={(e) => changePhoto(e.target.value)}
          />
        </div>
        <p className="text-white">(JPG-PNG) Máx. 3mb.</p>
        <p className='text-white mt-4'>Describe el siniestro (*)</p>
        <div className="form-group">
          <textarea
            className="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
            name='descrip'
            /*onChange={(e) => changeDescrip(e.target.value)}*/
          ></textarea>
        </div>

        <p className='text-white mt-4'>Escribe tu ubicación</p>
        <input
          u className="form-control bg-white"
          type="text"
          name='location'
          /*onChange={(e) => changeLocation(e.target.value)}*/
        />
        <p className="text-white">Selecciona con <strong>Google Maps</strong>
          <img src="https://s3-alpha-sig.figma.com/img/eb9e/82cf/1537f3021973aa42125112d1f74e0b4f?Expires=1647820800&Signature=bnafOKDkBrlUU5RTrxIPj2n8y7rZtpnXTv23Z2U0eLa7I3YDZLmHlyyYivE~whifA~mf1kEoxUbE7B43hp8TbVdr4g9FHZHj~n980jj7PwAibF6y6HON33jdn1P~Svquxp8rfzUmy0ryViFRQeX1FCWCdy0rON4HSsaDUdYaxJIfxhbfmoaNNKjFQDcqFaX7kdwCqZUWr2jvYnls~XB4YbK2UpZa~ey1QFqPaHcNgFZlU8T-1RZnSNzj8GWIg1dl2olTxyRcznRW~XWGZRWFSJiRhmg76LWhxYm0cwKjpaoT3ZOKYGKxS7PxCNfGZzIfOq5l-KC2cQzm~LFN7QD89Q__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA" width="35" height="25" alt="" />
        </p>

        <p className="text-white">Fecha del siniestro</p>
        <input
          s className="form-control bg-white"
          type="date"
          name='date'
          /*onChange={(e) => changeDate(e.target.value)}*/
        />

        <p className="text-white mt-4">¿Requieres automóvil de repuesto?</p>
        <div className="custom-control custom-radio custom-control-inline">
          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
          <label className="form-check-label text-white" htmlFor="inlineRadio1">Si</label>
        </div>
        <div className="custom-control custom-radio custom-control-inline">
          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
          <label className="form-check-label text-white" htmlFor="inlineRadio2">No</label>
        </div>

        <div className="custom-control custom-checkbox mt-4">
          <input type="checkbox" className="custom-control-input" id="customCheckDisabled" />
          <label className="custom-control-label text-white" htmlFor="customCheckDisabled">¿Aceptas los <strong>Términos y condiciones</strong>?</label>
        </div>
        <Link to="/PolizaInpaga">
        <button className='btn btn-lg mt-4 text-dark' id='btn-sinister' type="submit">Agregar siniestro</button>
        </Link>
      </form>
      <div className='mt-4 d-flex flex-row-reverse'>
        <img src="https://s3-alpha-sig.figma.com/img/7498/b36d/d6db347539020ca8b1270565eb70f8ab?Expires=1647820800&Signature=W1oQBoMo0IJEIiiurB5PA11d8Y0JtEMPye1RnnC1VlSBUqHWHNziM7VXKiJ8Qs8OZ6AtokBmxieQf842Tnf5iiJQcLvRNSFB8RYOgCJY7wUBI7xMgznvDPACMv-LDpaFOM7ciEbzPIqRcPLMFMb6Tx9lbvdUBYfdIg7dQXspHFpwdY2ttt3Yg0KawxVsIhwTloYeEpMI3No3dgyEWZHtUDSRWJ4TCs7OzUUu85P~II1tbMg9so49X5~kwOFu-JzhWFJ~8gaKIRjVf7vnnNWrjkDZc6cqW4fulbxGwRgoXxO04lo2fB-9biCd2az6F2f5fk2JvIacYeB0Nu6CvWeVcQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA" width="80" height="70" alt="" />
        <p className="text-white">¿Necesitas Ayuda?</p>
      </div>
    </div>
  )
}

export default IngresoPoliza;